import {isDoubleDimensionArray} from "../typeguards/isDoubleDimensionArray";

export function prepareArrayToUpperCase(arr : string[] | string[][]) {
  if (isDoubleDimensionArray(arr)) {
    return arr.map(rows => rows.map(letter => letter.toUpperCase()))
  } else {
    return arr.map(letter => letter.toUpperCase())
  }
}